export const mediaSharesTranslations = {
  ko: {
    title: '공유 링크 관리',
    back: '뒤로',
    loading: '공유 링크를 불러오는 중이에요',
    appOnly: '쑥쑥찰칵 앱에서 열어주세요.',
    allMine: '내 전체 링크',
    familyFallback: '가족 {{id}}',
    leaderScope: '가족 전체 링크',
    memberScope: '내가 만든 링크',
    statusLabel: '상태',
    statusAll: '전체',
    statusActive: '사용 중',
    statusExpired: '만료',
    statusRevoked: '해제',
    mine: '내 링크',
    familyLink: '가족 링크',
    untitled: '제목 없는 공유',
    items: '항목 {{count}}개',
    expires: '{{date}}까지',
    copy: '링크 복사',
    copied: '복사했어요',
    copyFallback: '아래 링크를 길게 눌러 복사하세요.',
    comments: '댓글',
    reactions: '반응',
    revoke: '공유 해제',
    revokeConfirm: '이 링크의 공유를 해제할까요? 원본 사진과 영상은 삭제되지 않아요.',
    revoked: '공유를 해제했어요.',
    loadMore: '더 보기',
    empty: '관리할 공유 링크가 없어요.',
    retry: '다시 시도',
    error: '공유 링크를 불러오지 못했어요.',
    authError: '로그인 정보를 다시 확인해주세요.',
    denied: '이 링크를 관리할 권한이 없어요.',
    gone: '만료되거나 해제된 링크예요.',
    requestId: '문의 코드 {{id}}',
    saving: '저장 중',
  },
  en: {
    title: 'Manage share links', back: 'Back', loading: 'Loading share links',
    appOnly: 'Open this page in the Babyfolio app.', allMine: 'All my links',
    familyFallback: 'Family {{id}}', leaderScope: 'All family links', memberScope: 'My links',
    statusLabel: 'Status',
    statusAll: 'All', statusActive: 'Active', statusExpired: 'Expired', statusRevoked: 'Revoked',
    mine: 'My link', familyLink: 'Family link', untitled: 'Untitled share', items: '{{count}} items',
    expires: 'Until {{date}}', copy: 'Copy link', copied: 'Copied',
    copyFallback: 'Press and hold the link below to copy it.', comments: 'Comments', reactions: 'Reactions',
    revoke: 'Revoke', revokeConfirm: 'Revoke this link? The original photos and videos will remain.',
    revoked: 'Share revoked.', loadMore: 'Show more', empty: 'No share links to manage.',
    retry: 'Try again', error: 'Could not load share links.', authError: 'Please check your sign-in.',
    denied: 'You cannot manage this link.', gone: 'This link has expired or was revoked.',
    requestId: 'Support code {{id}}', saving: 'Saving',
  },
  ja: {
    title: '共有リンク管理', back: '戻る', loading: '共有リンクを読み込んでいます',
    appOnly: 'すくすくチャッカクアプリで開いてください。', allMine: '自分の全リンク',
    familyFallback: '家族 {{id}}', leaderScope: '家族全体のリンク', memberScope: '自分のリンク',
    statusLabel: '状態',
    statusAll: 'すべて', statusActive: '使用中', statusExpired: '期限切れ', statusRevoked: '解除済み',
    mine: '自分のリンク', familyLink: '家族リンク', untitled: 'タイトルなし', items: '{{count}}件',
    expires: '{{date}}まで', copy: 'リンクをコピー', copied: 'コピーしました',
    copyFallback: '下のリンクを長押ししてコピーしてください。', comments: 'コメント', reactions: 'リアクション',
    revoke: '共有を解除', revokeConfirm: 'このリンクの共有を解除しますか？元の写真や動画は削除されません。',
    revoked: '共有を解除しました。', loadMore: 'もっと見る', empty: '管理できる共有リンクはありません。',
    retry: '再試行', error: '共有リンクを読み込めませんでした。', authError: 'ログイン情報を確認してください。',
    denied: 'このリンクを管理する権限がありません。', gone: '期限切れまたは解除済みのリンクです。',
    requestId: 'お問い合わせコード {{id}}', saving: '保存中',
  },
} as const;
